import gql from 'graphql-tag'

export default {
  service() {
    return {
      query: gql`
        query Query($serviceId: ID!) {
          service(id: $serviceId) {
            speedtests {
              id
              scheduled_for
              status
              started_at
              completed_at
              test_isolated
              result
              test_suite {
                id
                name
              }
            }
          }
        }
      `,
      variables() {
        return {
          serviceId: this.$route.params.id
        }
      }
    }
  }
}
